export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const emailPatternValidation = emailRegex
  .toString()
  .substr(1, emailRegex.toString().length - 2);
